export interface DashboardElement {
    name: string;
    path: string;
}

export enum DashboardPaths {
    Contracts = '/dashboard/projects',
    // '/dashboard/benefits' already belongs to the benefit template outcomes dashboard
    Benefits = '/dashboard/benefits-overview',
    BenefitTemplates = '/dashboard/benefits',
    ContractPriorities = '/dashboard/project-priorities',
    BenefitPriorities = '/dashboard/benefit-priorities',
}
